module.exports = __webpack_public_path__ + "1024eb2f69fb3e34624972122f4fe9e0.obj";